import React from "react"
import { NavigationProp } from "@react-navigation/core"
import { Text, View } from "react-native"
import { BadgeLayouts, HomeScreens, AuthThunks } from "@modules"
import { Title16, Title22 } from "@stylesheets"
import { useDispatch, useSelector } from "react-redux"
import { GlobalState } from "@redux"
import { OpenBook } from "@assets/icons/OpenBook"
import { Megaphone } from "@assets/icons/Megaphone"
import { UserProfile } from "@assets/icons/UserProfile"
import { Button } from "@modules/profile/screens/SettingsScreen/MfaSetup/Button"
import { Wallet } from "@assets/icons/Wallet"
import { HistoryTicket } from "@assets/icons/HistoryTicket"
import { Dish } from "@assets/icons/Dish"
import { CashSystem } from "@foodi/core"
import { I18n } from "react-redux-i18n"
import { CheckCircle } from "@assets/icons/CheckCircle"
import { useDevices } from "@hooks"
import { successLandingStyles } from "./styles"

type SuccessLandingProps = {
  navigation: NavigationProp<any>
  layoutHandler?: (event: any, key: BadgeLayouts) => void
}

export const SuccessLanding = ({
  navigation,
  layoutHandler,
}: SuccessLandingProps) => {
  const { selectedHolding, hasBadge } = useSelector(
    (state: GlobalState) => state.account
  )

  const dispatch = useDispatch()

  const Title: React.FC<any> = Title22

  const isTransactionsAllowed =
    hasBadge && selectedHolding?.idCashSystem?.toString() !== CashSystem.OTHERS

  const icons = [
    {
      icon: OpenBook,
      description: I18n.t("associationBadge.successLanding.menus"),
      visible: true,
    },
    {
      icon: Megaphone,
      description: I18n.t("associationBadge.successLanding.news"),
      visible: true,
    },
    {
      icon: UserProfile,
      description: I18n.t("associationBadge.successLanding.profile"),
      visible: true,
    },
    {
      icon: Dish,
      description: I18n.t("associationBadge.successLanding.digitalOffers"),
      visible: true,
    },
    {
      icon: Wallet,
      description: I18n.t("associationBadge.successLanding.balance"),
      visible: isTransactionsAllowed,
    },
    {
      icon: HistoryTicket,
      description: I18n.t("associationBadge.successLanding.history"),
      visible: isTransactionsAllowed,
    },
  ]

  const [isMobile] = useDevices()

  const styles = successLandingStyles(isMobile)

  const onPressHandler = async () => {
    await dispatch(AuthThunks.getUserInfo(undefined, true));
    navigation.navigate(HomeScreens.HOME_SCREEN)
  }

  return (
    <View
      style={styles.main}
      onLayout={(e) => layoutHandler?.(e, BadgeLayouts.SuccessLanding)}
    >
      <View style={styles.topView}>
        <View style={styles.titleContainer}>
          <Title isBlack>
            {I18n.t("associationBadge.successLanding.mainTitle")}
          </Title>
        </View>
        <View style={styles.iconContainer}>
          <CheckCircle size={80} />
        </View>
        <Title16 style={styles.title16}>
          {I18n.t("associationBadge.successLanding.successLink")}
        </Title16>
        <Title16 bold style={styles.title16Bold}>
          {selectedHolding?.name}
        </Title16>
      </View>
      <View style={styles.bottomView}>
        <Title16 style={styles.proposedTitle}>
          {I18n.t("associationBadge.successLanding.proposedServices")}
        </Title16>

        <View style={styles.container}>
          <View style={styles.iconsContainer}>
            {icons.map((Icon, index) => {
              if (!Icon.visible) {
                return null
              }

              return (
                <View key={index} style={styles.iconItem}>
                  <View style={styles.iconWrapper}>
                    <Icon.icon size={35} />
                  </View>
                  <Text style={styles.iconText}>{Icon.description}</Text>
                </View>
              )
            })}
          </View>
        </View>
        <Button style={styles.button} onPress={onPressHandler}>
          <Text style={styles.buttonText}>
            {I18n.t("associationBadge.successLanding.goToMySpace")}
          </Text>
        </Button>
      </View>
    </View>
  )
}
